module.exports = __webpack_public_path__ + "media/bg1.750729e1.mp4";